var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppSwitcherCaretBase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.957 5C4.77432 4.99999 4.59513 5.05002 4.43888 5.14466C4.28263 5.2393 4.15529 5.37493 4.07068 5.53684C3.98607 5.69874 3.94742 5.88072 3.95894 6.06304C3.97045 6.24535 4.03169 6.42103 4.136 6.571L6.769 10.355C6.90717 10.5534 7.09128 10.7155 7.30562 10.8275C7.51996 10.9394 7.75819 10.9979 8 10.9979C8.24181 10.9979 8.48004 10.9394 8.69438 10.8275C8.90872 10.7155 9.09283 10.5534 9.231 10.355L11.864 6.571C11.9683 6.42103 12.0295 6.24535 12.0411 6.06304C12.0526 5.88072 12.0139 5.69874 11.9293 5.53684C11.8447 5.37493 11.7174 5.2393 11.5611 5.14466C11.4049 5.05002 11.2257 4.99999 11.043 5H4.957Z",
    fill: "#2D3748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppSwitcherCaretBase);
export default __webpack_public_path__ + "static/media/app-switcher-caret-base.3b29dc44bde26f8a0eea787535a418b8.svg";
export { ForwardRef as ReactComponent };